export class ICalUrls {
	guideUrl: string;
	professionalUrl: string;
}
